
// frontend/geopolitikia/src/components/MobileMap.jsx
import React, { useState } from 'react';
import {
  Shield,
  Swords,
  MapPin,
  User,
  Info,
  Thermometer,
  Calendar,
  Waves,
  TreePine
} from "lucide-react";
import Carte from "./Carte.jsx";

const MobileMap = ({ gameState, loading, handleOpenPopin, gridData = null }) => {
  const [showLegend, setShowLegend] = useState(false);
  const [showClimate, setShowClimate] = useState(false);

  return (
    <div className="relative h-full bg-gradient-to-b from-slate-800 to-slate-900 overflow-hidden">
      {loading && (
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="spinner border-4 border-cyan-500 border-t-transparent rounded-full w-8 h-8 animate-spin" />
        </div>
      )}

      <div className="absolute top-4 left-4 right-4 flex justify-between items-center z-10">
        <button
          onClick={() => setShowLegend(!showLegend)}
          className="bg-slate-800/90 text-cyan-400 px-3 py-2 rounded-lg border border-cyan-500/30 flex items-center gap-2"
        >
          <Info size={16} />
          Légende
        </button>
        <button
          onClick={() => setShowClimate(!showClimate)}
          className="border-purple-500/30 px-3 py-2 rounded-lg border text-white text-sm bg-slate-800/90 flex items-center gap-2"
        >
          <Info size={16} />
          Monde {gameState.year}
        </button>
      </div>

      <main className="bg-gradient-to-br from-slate-800 via-blue-500 to-blue-800 shadow-2xl border border-slate-700 overflow-hidden">
        <div className="w-full h-full">
          <Carte
            countries_dict={gameState.countries_dict}
            ocean={gameState?.climate?.ocean}
            onOpenPopin={handleOpenPopin}
            gridData={gridData}
            playerCountryId={gameState?.joueur?.id}
          />
        </div>

      </main>
      {showLegend && (
        <div className="absolute top-14 left-4 gap-4 bg-slate-900/95 border border-slate-600 rounded-lg p-4 max-w-xs">
          <h3 className="text-white font-bold mb-2">Légende</h3>
          <div className="flex items-center gap-2 p-2">
            <Shield size={16} className="text-emerald-400" />
            <span className="text-emerald-300">Alliés</span>
          </div>
          <div className="flex items-center gap-2 p-2">
            <Swords size={16} className="text-red-400" />
            <span className="text-red-300">Ennemis</span>
          </div>
          <div className="flex items-center gap-2 p-2">
            <MapPin size={16} className="text-slate-400" />
            <span className="text-slate-300">Neutres</span>
          </div>
          <div className="flex items-center gap-2 p-2">
            <User size={16} className="text-blue-400" />
            <span className="text-blue-300">Vous</span>
          </div>
          <div className="flex items-center gap-2 p-2">
            <span fontSize="14" textAnchor="middle" fill="#60a5fa">🏢</span>
            <span className="text-blue-300">Villes</span>
          </div>
          <div className="flex items-center gap-2 p-2">
            <span fontSize="14" textAnchor="middle" fill="#60a5fa">🔵</span>
            <span className="text-blue-300">Ressources importantes</span>
          </div>
        </div>
      )}
      {showClimate && (
        <div className="absolute top-14 right-4 bg-slate-900/95 border border-slate-600 rounded-lg p-4 max-w-xs">
          <h3 className="text-white font-bold mb-2">État du Monde</h3>
          <div className="grid gap-2 text-xs">
            <div className="flex items-center gap-2 text-lg p-1">
              <Thermometer size={16} className="text-orange-400" />
              <span className="text-slate-300">Temp:</span>
              <span className="text-orange-400">{gameState.climate.degree}°C</span>
            </div>
            <div className="flex items-center gap-2 text-lg p-1">
              <Calendar size={16} className="text-cyan-400 " />
              <span className="text-slate-300">Année:</span>
              <span className="text-cyan-400">{gameState.year}</span>
            </div>
            <div className="flex items-center gap-2 text-lg p-1">
              <Waves size={16} className="text-blue-400" />
              <span className="text-slate-300">Océan:</span>
              <span className="text-blue-400">+{gameState.climate.ocean}cm</span>
            </div>
            <div className="flex items-center gap-2 text-lg p-1">
              <TreePine size={16} className="text-green-400" />
              <span className="text-slate-300">Bio:</span>
              <span className="text-green-400">67%</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileMap;
